<template>
    <div style="position:relative; top:190px;">

        <content-header
            icona="fas fa-check"
            :titolo="'Benvenuto ' + nominativo"
        ></content-header>

        
        <div class="card sn-card-contenuto">
            <div class="card-body">

                <!-- ****** GRIGLIA ****** -->
                <!-- ********************* -->
                <template v-if="mostraGriglia">
                    <h5>Corsi disponibili</h5>

                    <button type="button" class="btn btn-dark" @click="GetCorsiDisponibili()">
                        <i class="fas fa-sync"></i>&nbsp;
                    </button>&nbsp;

                    <br /><br />

                    <!-- **** GRIGLIA CORSI **** -->
                    <div v-for="(c, i) in dtCorsi" :key="i" class="card mb-3">
                        <div class="card-body" :class="{'bg-ev-passato': c.passato}">
                            <div class="d-flex flex-column flex-md-row justify-content-between align-items-start">
                                <!-- Colonna principale -->
                                <div>
                                    <h5 class="mb-1">
                                        {{ c.cor_titolo }}
                                        <span class="badge text-bg-secondary" v-if="c.passato">Passato</span>
                                        <span class="badge text-bg-success" v-if="c.incorso">In corso</span>

                                    </h5>
                                    <p class="mb-1">Tipo: <span class=" text-success">{{ c.cot_descrizione }}</span></p>
                                    <p class="mb-1">Nr. partecipanti: {{ c.npartecipanti }}</p>
                                    <p class="mb-0">
                                    dal {{ c.cor_dta_inizio }} al {{ c.cor_dta_fine }}
                                    </p>
                                </div>

                                <!-- Azioni -->
                                <div class="mt-3 mt-md-0">
                                    <button type="button" class="btn btn-sm btn-info me-2 mt-1" title="Registro" @click="AttivaRegistro(c)" >
                                        <i class="fas fa-list fa-fw"></i> Registro
                                    </button>
                                    <button type="button" class="btn btn-sm btn-primary me-2 mt-1" title="Partecipanti" @click="c.selected = !c.selected" >
                                        <i class="fas fa-users fa-fw"></i> Partecipanti
                                    </button>
                                </div>
                            </div>

                            <!-- ****** PARTECIPANTI (panel) ****** -->
                            <!-- ********************************** -->
                            <div class="d-flex flex-column flex-md-row justify-content-between align-items-start mt-3" v-if="c.selected">
                                <table class="table table-sm">
                                    <thead>
                                        <tr>
                                            <th>Cognome e nome</th>
                                            <th>Cod. Fis.</th>
                                            <th>Email</th>
                                            <th>Acc .Code</th>
                                            <th>Q. inizio</th>
                                            <th>Q. finale</th>
                                            <th>Azioni</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="p, ip in c.partecipanti" :key="ip">
                                            <td>{{ p.per_cognome}} {{ p.per_nome }}</td>
                                            <td>{{ p.per_cf }}</td>
                                            <td>{{ p.per_email }}</td>
                                            <td>{{ p.per_accessCode }}</td>
                                            <td>
                                                <span v-if="p.statoTestInizio == 0">--</span>
                                                <a href="#j" v-if="p.statoTestInizio == 1" @click="MostraRisultati(c, p, 1)"><i class="fas fa-check-circle text-success"></i></a>
                                                <a href="#j" v-if="p.statoTestInizio == 2" @click="MostraRisultati(c, p, 1)"><i class="fas fa-times-circle text-danger"></i></a>
                                            </td>
                                            <td>
                                                <span v-if="p.statoTestFine == 0">--</span>
                                                <a href="#j" v-if="p.statoTestFine == 1" @click="MostraRisultati(c, 2)"><i class="fas fa-check-circle text-success"></i></a>
                                                <a href="#j" v-if="p.statoTestFine == 2" @click="MostraRisultati(c, 2)"><i class="fas fa-times-circle text-danger"></i></a>
                                            </td>
                                            <td>
                                                <button type="button" class="btn btn-sm btn-primary" @click="InviaLink(p.per_id)"><i class="fas fa-paper-plane"></i>&nbsp;Invia link accesso</button>&nbsp;
                                            </td>
                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </template>

                <!-- ****** REGISTRO ****** -->
                <!-- ********************** -->
                <template v-if="mostraRegistro">
                    <div class="card">
                        <div class="card-header">
                            <button type="button" class="btn btn-sm btn-outline-dark me-2" @click="ChiudiRegistro()">Chiudi</button>
                            <button type="button" class="btn btn-sm btn-primary" @click="SalvaRegistro()">Salva</button>
                        </div>
                        <div class="card-body">
                            <h5>Registro</h5>
                            <p>Corso: <strong>{{ oRegistro.cor_titolo }}</strong></p>
                            <p>Periodo: dal {{ oRegistro.cor_dta_inizio }} al {{ oRegistro.cor_dta_fine }}</p>

                            <template v-for="gg, ig in GiorniRegistro(oRegistro.cor_dta_inizio, oRegistro.cor_dta_fine)" :key="ig">
                                <div class="row mb-4">
                                    <span class="bg-giorno" :class="{'bg-oggi': FormattaData(AddDay(ig)) == FormattaData(new Date())}">Presenze del giorno: {{ FormattaData(AddDay(ig)) }}</span> 
                    
                                    <hr />
                                    <table class="table table-sm">
                                        <thead>
                                            <tr>
                                                <th>Cognome e nome</th>
                                                <th>Ora Ingresso matt.</th>
                                                <th>Ora Uscita matt.</th>
                                                <th></th>
                                                <th>Ora Ingresso pom.</th>
                                                <th>Ora Uscita pom.</th>
                                                <th></th>
                                                <th>Approvato</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="rp, irp in PartecipantiGiorno(AddDay(ig))" :key="irp">
                                                <td>{{ rp.cognome}} {{ rp.nome }}</td>
                                                <!-- mattina -->
                                                <td>
                                                    <input type="time" class="form-control" style="width:80px;" v-model="rp.reg_ora_entrata_m" @keyup="startModificaRegistro = true">
                                                </td>
                                                <td>
                                                    <input type="time" class="form-control" style="width:80px;" v-model="rp.reg_ora_uscita_m" @keyup="startModificaRegistro = true">
                                                </td>
                                                <td>
                                                    <i class="fas fa-check text-success" v-if="rp.reg_ora_entrata_m !='' && rp.reg_ora_uscita_m != ''"></i>
                                                </td>
                                                <!-- pomeriggio -->
                                                <td>
                                                    <input type="time" class="form-control" style="width:80px;" v-model="rp.reg_ora_entrata_p" @keyup="startModificaRegistro = true">
                                                </td>
                                                <td>
                                                    <input type="time" class="form-control" style="width:80px;" v-model="rp.reg_ora_uscita_p" @keyup="startModificaRegistro = true">
                                                </td>
                                                <!-- flag -->
                                                <td>
                                                    <i class="fas fa-check text-success" v-if="rp.reg_ora_entrata_p !='' && rp.reg_ora_uscita_p != ''"></i>
                                                </td>
                                                <!-- Approvato dal docente -->
                                                <td>
                                                    <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" v-model="rp.reg_approvato">
                                                    </div>
                                                </td>
                                                
                                                
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                
                            </template>

                            <!-- <template v-for="rday, ir in oRegistro.registro" :key="ir">
                                <strong>Presenze del giorno: </strong>
                            </template> -->

                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-sm btn-outline-dark me-2" @click="ChiudiRegistro()">Chiudi</button>
                            <button type="button" class="btn btn-sm btn-primary" @click="SalvaRegistro()">Salva</button>
                        </div>

                    </div>
                    
                </template>





                
            
            

            </div>
        </div>



        <!-- *** DIALOG MOSTRA RISULTATI *** -->
        <dialog class="dialogMostraRisultati">
            <div class="d-flex mb-3" style="border-bottom:solid 1px #ccc" >
                <div class="">
                    <i class="fas fa-poll text-primary"></i>
                </div>
                <div class="ms-2">
                    <h5>Risultati per {{ oRisultati.nominativo }}</h5>
                </div>
            </div>

            <h5>{{ oRisultati.tipo }}</h5>

            <template v-for="q, iq in dtRisultati" :key="iq" >
                <div class="d-flex mb-3">
                    Esito Test <span v-if="q.qrs_passed" class="text-success">&nbsp;SUPERATO&nbsp;</span> <span v-else class="text-danger">&nbsp;FALLITO&nbsp;</span> con un punteggio di {{ q.qrs_punteggio }} in data {{ FormattaData(q.qrs_fine) }}
                </div>
                <ul style="list-style-type: none;">
                    <li v-for="d, id in q.domande" :key="id" class="mb-4">
                        <em >{{ d.qdo_testo }}</em>
                        <ol class="mt-2">
                            <li v-for="r, ir in d.risposte" :key="ir" class="m-2">
                                <span v-if="r.rispostaData"><i class="fas fa-check" :class="{'text-success': r.rispostaData & r.qri_valore, 'text-danger': !(r.rispostaData & r.qri_valore)}"></i>&nbsp;</span>{{ r.qri_testo }} <strong v-if="r.qri_valore">*GIUSTA*</strong>
                            </li>
                        </ol>
                    </li>
                </ul>

                <div class="d-flex mt-3">
                    <button type="button" class="btn btn-danger me-2" @click="AnnullaRisultato(q.qrs_idrs)">Annulla questo risultato</button>
                </div>
                

            </template>

            <div class="d-flex justify-content-end">
                
                <button type="button" class="btn btn-outline-dark me-2" @click="ChiudiRisultati">Chiudi</button>
            </div>

        </dialog>


    </div>
  
    

   
    
</template>

<script>
import ContentHeader from '@/components/layout/ContentHeader.vue';
import snFunctions from '@/lib/snFunctions.js';

export default {
    name: 'DashboardView',
    components: {
        ContentHeader
    },
    inject: ['cfg'],
    data: function() {
        return {
            dtCorsi: [],
            dtRisultati: [],

            oRegistro: {
                cor_id: -1,
                cor_titolo: "",
                cor_dta_inizio: "",
                cor_dta_fine: "",
                registro: [],
                
            },

            oRisultati: {
                tipo: "",
                nominativo: "",
                risultati: {}
            },
           
            nominativo: "",

            
            mostraGriglia: true,
            mostraRegistro: false,

            startModificaRegistro: false,

            oRegistroCorrente: null,
           
            
        }
    },
    methods: {
        AttivaGriglia() {
            this.mostraGriglia = true;
            this.mostraRegistro = false;
        },
        AttivaRegistro(o) {
            this.mostraGriglia = false;
            this.mostraRegistro = true;

            this.oRegistroCorrente = o;

            this.startModificaRegistro = false;

            this.oRegistro.cor_id = o.cor_id;
            this.oRegistro.cor_titolo = o.cor_titolo;
            this.oRegistro.cor_dta_inizio = o.cor_dta_inizio;
            this.oRegistro.cor_dta_fine = o.cor_dta_fine;

            this.$store.commit('Messaggio', {parms: [true, ['Caricamento in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/DashDocenti/GetRegistro?token=" + this.$store.state.UserInfo.token + "&idCor=" + o.cor_id)
                .then(response => response.json())
                .then(obj => {
                    this.oRegistro.registro = obj;

                    this.$store.commit('Messaggio', {parms: [true, ['Fatto. '], 'alert alert-success', 'fa-check', false, 2000]});
                });
        },
        GetCorsiDisponibili() {
            //Carica lista elementi
            this.$store.commit('Messaggio', {parms: [true, ['Caricamento in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/DashDocenti/GetCorsiDisponibiliDoc?token=" + this.$store.state.UserInfo.token)
                .then(response => response.json())
                .then(obj => {
                    this.dtCorsi = obj;

                    this.$store.commit('Messaggio', {parms: [true, ['Fatto. '], 'alert alert-success', 'fa-check', false, 2000]});
                });
        },
        ChiudiRegistro() {
            if(this.startModificaRegistro) {
                if(confirm("Ci sono delle modifiche non salvate, vuoi continuare?")) this.AttivaGriglia()
            } else {this.AttivaGriglia();}
            
        },
        SalvaRegistro() {
            let oSubmit = [];
            oSubmit = this.oRegistro;
            oSubmit.token = this.$store.state.UserInfo.token;

            this.$store.commit('Messaggio', {parms: [true, ['Salvataggio in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/DashDocenti/SalvaRegistro", {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(oSubmit)
            }).then(response => response.json())
                .then(obj => {
                    if (obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Salvataggio effettuato.'], 'alert alert-success', 'fa-check', false, 2000]});

                        this.startModificaRegistro = false;
                        this.AttivaRegistro(this.oRegistroCorrente);
                    
                    
                    }
                    else {
                        this.$store.commit('Messaggio', {parms: [true, ["Sono presenti errori di compilazione"], 'alert alert-warning', 'fa-times', false, 3000]});

                        // this.mostraMessaggio = true;
                        // this.alertMessaggio = obj.dati;
                        // this.alertClass = "alert alert-warning";
                        // this.alertIcon = "fa-xmark"
                        // this.alertIconSpin = false
                    }
                });
        },

        InviaLink(idPer) {
            let aSel =  [];
            aSel.push(idPer)

            if(confirm("Vuoi inviare il codice di accesso?")) {
                fetch(this.cfg.apisrv + "/api/Personale/InviaLink?token=" + this.$store.state.UserInfo.token + "&ids=" + aSel.toString())
                .then(response => response.json())
                .then(obj => {
                    if(obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Link inviato'], 'alert alert-success', 'fa-check', false, 2000]});
                    } else {
                        this.$store.commit('Messaggio', {parms: [true, [obj.errorMessage], 'alert alert-danger', 'fa-times', false, 2000]});
                    }
                    
                });
            }
        },

        // ***** RISULTATI *****

        MostraRisultati(c, p, tipo) {
            const dialog = document.querySelector(".dialogMostraRisultati");
            dialog.showModal();

            let idQue = -1;
            if(tipo == 1) { this.oRisultati.tipo = "Valutazione ingresso"; idQue = c.cor_idQueInizio; } 
            if(tipo == 2) {this.oRisultati.tipo = "Valutazione finale"; idQue = c.cor_idQueFine; }
            this.oRisultati.nominativo = p.per_cognome + ' ' + p.per_nome;
            //this.oRisultati.

            //recupera risultati
            fetch(this.cfg.apisrv + "/api/DashDocenti/RisultatiUtente?token=" + this.$store.state.UserInfo.token + "&idusr=" + p.per_email + "&idQue=" + idQue + "&idCor=" + c.cor_id )
                .then(response => response.json())
                .then(obj => {
                    this.dtRisultati = obj;
                });


        },
        ChiudiRisultati() {
            const dialog = document.querySelector(".dialogMostraRisultati");
            dialog.close();
        },
        AnnullaRisultato(idrs) {
           
            if(confirm("Sei sicuro di voler annullare l'esito di questo quiz?")) {
                fetch(this.cfg.apisrv + "/api/DashDocenti/AnnullaRisultato?token=" + this.$store.state.UserInfo.token + "&idrs=" + idrs)
                    .then(response => response.json())
                    .then(obj => {
                        if(obj.status == "OK") {
                            this.$store.commit('Messaggio', {parms: [true, ['Risultato cancellato'], 'alert alert-success', 'fa-check', false, 2000]});

                            const dialog = document.querySelector(".dialogMostraRisultati");
                            dialog.close();

                            this.GetCorsiDisponibili(); 
                        } else {
                            this.$store.commit('Messaggio', {parms: [true, [obj.errorMessage], 'alert alert-danger', 'fa-times', false, 2000]});
                        }
                       
                    });
            }


        },



        // *** QUERY E VISTE
        GiorniRegistro(dt1,dt2) {
            let d1 = new Date(dt1.substring(6), parseInt(dt1.substring(3, 5), 10) -1, dt1.substring(0, 2))
            let d2 = new Date(dt2.substring(6), parseInt(dt2.substring(3, 5), 10) -1, dt2.substring(0, 2))

            //azzero l'ora
            //d1.setHours(0, 0, 0, 0);
            d2.setHours(23, 59, 59, 999);

            let diff = d2.getTime() - d1.getTime();

            return Math.round(diff / (1000 * 60 * 60 * 24));
        },
        PartecipantiGiorno(g) {
            //oRegistro.registro
            let sDta = snFunctions.dateFormat(g, "yyyy-MM-dd");
            //console.log(sDta)
            return this.oRegistro.registro.filter((p) => p.reg_data.startsWith(sDta));
        },



       
        // *** ALTRI METODI
        AddDay(giorni) {
            let nd = new Date(this.oRegistro.cor_dta_inizio.substring(6), parseInt(this.oRegistro.cor_dta_inizio.substring(3, 5), 10) -1, this.oRegistro.cor_dta_inizio.substring(0, 2))
            nd.setDate(nd.getDate() + giorni); // Aggiunge i giorni
            return nd;


        },
        FormattaData(dta) {
            return snFunctions.dateFormat(dta, "dd-MM-yyyy");
        },
       

    },
    mounted: function() {
        if(this.$store.state.UserInfo.token == '') this.$router.push("/");

        this.nominativo = this.$store.state.UserInfo.cognome + ' ' + this.$store.state.UserInfo.nome;

        this.GetCorsiDisponibili();
    }
}
</script>


<style>
    .bg-ev-passato {
        background-color: #eee;    
    }

    .bg-giorno {
        background-color: #eee;    
        font-weight: bold;
    }

    .bg-oggi  {
        background-color: #D9DFC6;    
    }
</style>